export const SHOW_NONE = Symbol('Show no modal');
export const SHOW_EDITOR = Symbol('Show editor modal');
export const SHOW_PUBLISH = Symbol('Show publish modal');
